/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Combobox_ClearInputs */

const vi_combobox_clear = /** @type {(inputs: Combobox_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xóa lựa chọn`)
};

/**

* @param {Combobox_ClearInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const combobox_clear = /** @type {((inputs?: Combobox_ClearInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Combobox_ClearInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_combobox_clear(inputs)
});